export function TableHeading({ name }) {
  return (
    <th className="border border-gray-300 px-4 py-2 text-sm text-start font-normal uppercase text-gray-600">
      {name}
    </th>
  );
}
export function TableData({ children }) {
  return <td className="px-4 py-2 text-start max-w-[700px]">{children}</td>;
}
